var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"login",on:{"click":_vm.logout}},[_vm._v("\n        退出\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }